module.exports = __webpack_public_path__ + "img/bottom.c6562394.svg";